import { render, staticRenderFns } from "./EditPageSpecificQuestion.vue?vue&type=template&id=1dc6ef55"
import script from "./EditPageSpecificQuestion.vue?vue&type=script&lang=ts"
export * from "./EditPageSpecificQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports